import { Redirect, usePathname } from "expo-router";

export default function LocationPage() {
  const pathname = usePathname();

  return <Redirect href={(pathname + "/residents") as any} />;
}
